module.exports = __webpack_public_path__ + "img/sec5_17.a43b6127.jpg";